import React from 'react';

const SectionLayout = ({ id, title, description, children, titleClass = '', descriptionClass = '' }) => {
  return (
    <section id={id} className={`section ${id} sec-pad`}>
      <div className="main-container">
        <h2 className="heading heading-sec heading-sec__mb-med">
          <span className={`heading-sec__main ${titleClass}`}>{title}</span>
          <span className={`heading-sec__sub ${descriptionClass}`}>{description}</span>
        </h2>
        <div className="section__content">{children}</div>
      </div>
    </section>
  );
};

export default SectionLayout;